import { Navigate, useParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { ApprovedEmailsAdmin } from "@/components/admin/approved-emails-admin";
import { Heading, PageShell, Text } from "@/components/ui";
import { useAuthStore } from "@/stores/authStore";

export function TenantAdminApprovedEmailsPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("allowlist");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }
  if (user?.role !== "tenant_admin") {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  return (
    <PageShell width="app" data-testid="tenant-admin-approved-emails">
      <Heading as="h1" level="page">
        {t("approvedTitle")}
      </Heading>
      <Text tone="muted" className="mt-2">
        {t("approvedSubtitle", { tenant: tenantSlug })}
      </Text>
      <div className="mt-8">
        <ApprovedEmailsAdmin />
      </div>
    </PageShell>
  );
}
